export const TEST_ID = 'primaryParamsSection';

export const LABELS = {
    altitude: 'Altitude (ft)',
    autoOptimizeAngle: 'Auto-optimize Angle',
    pathAngle: 'Path Angle',
    routeSpacing: 'Route Spacing (ft)',
    turnType: 'Turn Type'
};

export const ROUTE_SPACING = { max: 98, min: 2, step: 0.5, unit: 'ft' };

export const ROUTE_SPACING_METRIC_MAX = 30;

export const ROUTE_SPACING_METRIC_MIN = 0.5;

export const PATH_ANGLE = { max: 360, min: 0, step: 1, unit: 'deg' };

export const ALTITUDE = { max: 400, min: 3, step: 1, unit: 'ft' };

export const ALTITUDE_METRIC_MAX = 122;

export const ALTITUDE_METRIC_MIN = 1;

export const TURN_TYPE_OPTIONS = [
    { label: 'U-Turn', value: 'UTURN' },
    { label: 'Racetrack', value: 'RACETRACK' },
    { label: 'Straight', value: 'STRAIGHT' }
];

export const AUTO_OPTIMIZE_OPTIONS = [
    { label: 'Off', value: 'OFF' },
    { label: 'On', value: 'ON' }
];

export const AUTO_OPTIMIZE_ON_VALUE = 'ON';

export const AUTO_OPTIMIZE_ON_INDEX = 1;

export const AUTO_OPTIMIZE_OFF_INDEX = 0;
